import React from 'react';
import Link from 'next/link';

export default function ProjectsHero({ data }) {
  const title = data?.title || "Our Projects";
  const description = data?.description || "Explore our successful projects delivered for businesses across various industries. Each solution is designed to solve real-world problems and drive growth.";

  return (
    <div className="flex flex-col md:flex-row justify-between items-start md:items-end w-full mb-16 pt-4">
      <div className="flex-1 max-w-2xl">
        <div className="flex items-center text-gray-400 text-sm mb-4">
          <Link href="/" className="text-gray-400 hover:text-white transition-colors text-decoration-none">Home</Link>
          <span className="mx-2">&gt;</span>
          <span className="text-white">Projects</span>
        </div>
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">{title}</h1>
        <p className="text-gray-400 text-base md:text-lg whitespace-pre-wrap">
          {description}
        </p>
      </div>
      <div className="mt-6 md:mt-0">
        <Link href="/contact" className="inline-flex items-center gap-2 px-6 py-3 rounded-lg border-[1px] border-solid border-[#f1833b] text-white hover:bg-[#f1833b] hover:text-white transition-all duration-300 group">
          <span className="font-medium">Let's Build Yours</span>
          <svg className="w-5 h-5 text-[#f1833b] group-hover:text-white transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
          </svg>
        </Link>
      </div>
    </div>
  );
}
